module.exports = __webpack_public_path__ + "img/qrcode-1720.fabe2e88.png";